import { connect } from 'react-redux';

import { loggingActions } from "dataflow/distributorPortal/actions";

import { LoggingPresentation } from './LoggingPresentation';

function mapStateToProps(state) {
    const { 
        getLogs_requesting, getLogs_status, 
        logList, logListHeaders,
    } = state.distributorPortal_loggingReducers;
    
	return {
        getLogs_requesting, getLogs_status, 
        logList, logListHeaders,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getList: (pageNo, pageSize, sort, filterOptions) => { dispatch(loggingActions.getLogs(pageNo, pageSize, sort, filterOptions)); },
    };
}

const Logging = connect(mapStateToProps, mapDispatchToProps)(LoggingPresentation);

export default Logging;